/**
 * Import all required styles.
 */
import '../scss/app.scss';
/**
 * Import all required libraries.
 */
import Vue from 'vue';
import ServiceContainer from '@flashpointbv/solar-service-container';

/**
 * Register Vue components.
 */
ServiceContainer().addComponents([
  {key: 'kiyoh-review-block', concrete: () => import('./components/KiyohReviewBlock.vue')},
  {key: 'kiyoh-reviews-banner', concrete: () => import('./components/KiyohReviewsBanner.vue')},
  //Sliders and swipers
  {key: 'swiper', concrete: () => import('../../default/js/shaked-exports/swiper/swiper')},
  {key: 'swiper-slide', concrete: () => import('../../default/js//shaked-exports/swiper/swiper-slide')},
]);

new Vue({
  components: ServiceContainer().getComponents(),
  data: {
    csrfToken: window.csrfToken
  },
}).$mount('#solar-app');
